module.exports = __webpack_public_path__ + "img/banner1.f999aa25.png";